import "./footer.css"

import React, { useContext } from "react";

import { FormattedMessage } from "react-intl";
import { Link } from "gatsby";
import { LinkButton } from "./ui/Button";
import { LocaleContext } from "../locales-utils";
import Typo from "./ui/Typo";
import LogoWhite from "../svgs/logo-white.svg";
import LinkedinIcon from "../svgs/linkedin.svg";
import FooterSVG from "../svgs/footer.svg";
export default function Footer() {
  const locale = useContext(LocaleContext);

  return (
    <footer className="relative lg:pt-16 pt-10 pb-6 px-8 lg:px-16 text-white Footer bg-primary overflow-hidden">
      <div className="max-w-4xl">
        <div className="flex flex-row">
          <LogoWhite width="150" height="26.6" viewBox="0 0 199 35.27" className="mb-6" />
          <div className="ml-4 pl-2 border-l-white border-l-2">
            <Typo
              as="div"
              className=""
            >
              {locale.footer?.text || (
                <a href="/about-us#locations"><FormattedMessage
                  id="footer.text"
                  defaultMessage="<p>Paris</p><p>London</p><p>Singapore</p><p>Melbourne</p><p>Sydney</p>"
                  values={{
                    p: (...chunks) => <div className="mb-0.5">{chunks}</div>,
                  }}
                /></a>
              )}
            </Typo>
          </div>
        </div>
        
        <div className="Footer-links mt-2">

          <a
            href="https://mailchi.mp/theblunomy/t2ynzrkadn"
            target="_blank"
            className="Footer-link my-1"
          >
            <FormattedMessage id="footer.text" defaultMessage="Contact us" />
          </a>

          <a
            href="https://mailchi.mp/theblunomy/9lp2jxlkt3"
            target="_blank"
            className="Footer-link my-1"
          >
            <FormattedMessage id="footer.text" defaultMessage="Register for Blunomy's newsletter" />
          </a>

          <a
            href="https://www.welcometothejungle.com/en/companies/blunomy"
            target="_blank"
            className="Footer-link my-1"
          >
            <FormattedMessage id="footer.text" defaultMessage="Careers at Blunomy" />
          </a>

          <a
            href="https://linkedin.com/company/blunomy"
            target="_blank"
            title="LinkedIn"
            className="Footer-linkedin mt-3 mb-1"
          >
            <LinkedinIcon />
          </a>
        </div>
        

        <div className="mt-5">
          <Typo
            variant="p"
            as="div"
            className="flex flex-row flex-wrap text-xs leading-none divide-x md:items-center md:text-base "
          >
            <span className="pr-2 mb-2 md:mb-0 md:pr-4 md:py-0">
              <FormattedMessage
                id="footer.copyright"
                defaultMessage="© Blunomy 2025 — All rights reserved"
              />
            </span>

            <span className="px-2 mb-2 md:px-4 md:py-0 md:mb-0">
              <Link to={locale.footer?.legalTerms?.path}>
                {locale.footer?.legalTerms?.blunomyContent?.title}
              </Link>
            </span>
            <span className="px-2 mb-2 md:px-4 md:py-0 md:mb-0">
              <Link to={locale.footer?.privacy?.path}>
                {locale.footer?.privacy?.blunomyContent?.title}
              </Link>
            </span>
          </Typo>
        </div>
      </div>

      <FooterSVG className="Footer__svg"/>


    </footer>
  );
}
